import { useState, useCallback } from "react";
import Navbar from "@/components/Navbar";
import Contact from "@/components/Contact";
import LostAndFound from "@/components/LostAndFound";
import AnnouncementPopup from "@/components/AnnouncementPopup";
import { Outlet } from "react-router-dom";

const Layout = () => {
  const [showNewsButton, setShowNewsButton] = useState(false);
  const [announcementOpen, setAnnouncementOpen] = useState(false);

  const handleOpenAnnouncement = useCallback(() => {
    setAnnouncementOpen(true);
  }, []);

  const handleAnnouncementOpenChange = useCallback((open: boolean) => {
    setAnnouncementOpen(open);
  }, []);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Contact />
      <LostAndFound
        showNewsButton={showNewsButton}
        onNewsClick={handleOpenAnnouncement}
      />
      <AnnouncementPopup
        externalOpen={announcementOpen}
        onOpenChange={handleAnnouncementOpenChange}
        onShowNewsButton={setShowNewsButton}
      />
    </div>
  );
};

export default Layout;
